var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpectrumCuboid = function SvgSpectrumCuboid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 61 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54.234 38.547-6.12 6.953H5.86V21.454l6.12-6.954h42.254zm-41.895.244-5.281 5.945h40.494V38.79zM47.755 21.21l5.282-5.946H12.542v5.945zm5.715-5.27-5.153 5.79v16.296h5.153zm-5.153 28.12 4.72-5.27h-4.72zm-35.775-6.034h35.01V21.974h-35.01zM6.625 21.974V44.06l5.153-5.79V21.973zm5.153-.765v-5.27l-4.72 5.27z"
  })));
};
export default SvgSpectrumCuboid;